import React from "react";
import { FoodDto } from "../../api";
import { StepModification } from "../../data/dishModification";
import { getRenderKey } from "../../utils/renderUtils";
import { Badge } from "../ui/Badge";
import { QueryBoundary } from "../ErrorBoundary";
import { LookupSkeleton } from "../ui/LookupSkeleton";
import { FoodUnitLabel } from "./FoodName";

export const StepCompactView = ({
  step,
  index,
}: {
  step: StepModification;
  index: number;
  foods: FoodDto[];
}) => {
  const preview =
    step.text?.trim() || `Schritt ${index + 1} (noch ohne Beschreibung)`;
  return (
    <div className="flex min-w-0 flex-1 flex-col items-start gap-1">
      <p className="line-clamp-2 text-left text-sm text-ink">{preview}</p>
      {step.ingredients.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {step.ingredients.map((ing, i) => (
            <Badge key={getRenderKey(ing, i)} variant="ingredient">
              <QueryBoundary
                fallback={
                  <LookupSkeleton
                    dataCy="step-ingredient-name-loading"
                    className="h-3 w-16"
                  />
                }
              >
                <FoodUnitLabel unitId={ing.foodUnitId} amount={ing.amount} />
              </QueryBoundary>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};
